import { computed, ref, watch, type Ref } from 'vue';

import { useInfiniteScrollObserver } from '@/shared/lib';

export const RECIPIENT_ROWS_BATCH_SIZE = 50;

export function useRecipientRowsBatch<T>(rows: Ref<T[]>, triggerId: string) {
  const renderLimit = ref(RECIPIENT_ROWS_BATCH_SIZE);

  const renderedRows = computed(() => rows.value.slice(0, renderLimit.value));
  const hasMoreRows = computed(() => renderLimit.value < rows.value.length);

  watch(rows, () => {
    renderLimit.value = RECIPIENT_ROWS_BATCH_SIZE;
  });

  useInfiniteScrollObserver({
    enabled: hasMoreRows,
    loadingMore: ref(false),
    hasMore: hasMoreRows,
    onLoadMore: () => {
      renderLimit.value += RECIPIENT_ROWS_BATCH_SIZE;
    },
    triggerId,
    minIntervalMs: 100,
  });

  return { renderedRows, hasMoreRows };
}
